module.exports = __webpack_public_path__ + "static/image1-5ef789a9988dde3616b75d4ea20cef7f.jpg";